<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <app-form-field-text
    [field]="emailControl"
   
    label="label.email"
  ></app-form-field-text>
</div>
<div class="modal-footer">
  <button
    class="btn btn-primary"
    (click)="submit()"
  >
    {{ 'button.submit' | translate }}
  </button>
</div>
